<template>
  <div class="service-et-alarm">
    <p>{{ computedDescription }}</p>

    <alarm-status
      :alarm="alarm"
      :alarm-active="computedAlarmIsActive"
    />

    <hr>

    <slot v-if="computedAlarmIsActive">
      <!-- <div class="g-alarm-handler__row">
        <h3 class="g-text g-text--center">
          {{ $t('messages.alarms.suggestion') }}
        </h3>
        <p>
          {{ $t('messages.alarms.noAttention') }}
        </p>
      </div> -->
    </slot>
  </div>
</template>


<script>
import {ServiceAlarm} from '@/assets/javascript/mixins/ServiceAlarm'

export default {
  name: 'ServiceETAlarm',
  mixins: [ServiceAlarm],
  computed: {
    computedDescription() {
      return this.status ? this.$t('messages.alarms.serviceETAlarm.descriptionActive') : this.$t('messages.alarms.serviceETAlarm.descriptionPassive')
    }
  }
}
</script>
